import { render, staticRenderFns } from "./WorksRegistrationDialog.vue?vue&type=template&id=5117c687&scoped=true"
import script from "./WorksRegistrationDialog.vue?vue&type=script&lang=js"
export * from "./WorksRegistrationDialog.vue?vue&type=script&lang=js"
import style0 from "./WorksRegistrationDialog.vue?vue&type=style&index=0&id=5117c687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117c687",
  null
  
)

export default component.exports